jQuery(function ($) {
    // Universal handler to prevent Astra cart from freezing page (runs on all screen sizes)
    $(document.body).on('added_to_cart', function (e, fragments, cart_hash, $button) {
        // Remove Astra's mobile cart class immediately to prevent page freeze
        $('html').removeClass('ast-mobile-cart-active');
        $('#astra-mobile-cart-drawer').removeClass('active');

        // Keep checking and removing for a short period to win any race conditions
        setTimeout(function () {
            $('html').removeClass('ast-mobile-cart-active');
        }, 10);
        setTimeout(function () {
            $('html').removeClass('ast-mobile-cart-active');
        }, 100);
        setTimeout(function () {
            $('html').removeClass('ast-mobile-cart-active');
        }, 300);
    });

    // Mobile-specific popup handler
    $(document.body).on('added_to_cart', function (e, fragments, cart_hash, $button) {
        if (window.innerWidth <= 768) {

            if (fragments === null) {
                return;
            }
            // Prevent the default slide-out cart
            $('body').addClass('fishouflage-popup-open');

            // Unbind Astra's added_to_cart event listener
            $(document.body).off('added_to_cart.astra');

            // Immediately hide Astra's cart drawer with a slight delay to win race condition
            setTimeout(function () {
                $('#astra-mobile-cart-drawer').removeClass('active');
                $('html').removeClass('ast-mobile-cart-active');
            }, 10);

            var product_id = $button.data('product_id') ? $button.data('product_id') : $button.val();
            if ($('input[name="add-to-cart"]').length > 0) {
                product_id = $('input[name="add-to-cart"]').val();
            }



            // Remove any existing popups before creating a new one
            $('.fishouflage-add-to-cart-popup-wrapper').remove();
            // Create the popup HTML
            var popup_html = '<div class="fishouflage-add-to-cart-popup-wrapper"><div class="fishouflage-add-to-cart-popup-content"><div class="popup-header"><h3><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" /></svg>Item added to your cart</h3><button class="close-popup"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clip-rule="evenodd" /></svg></button></div><div class="cross-sells"><div class="shipping-progress"><p></p><div class="progress-bar"><span></span></div></div><h3>You Might Also Consider</h3><div class="products-wrapper"><div class="products"></div></div></div><div class="popup-footer"><div class="buttons"><a href="/cart" class="button view-bag">View Cart</a><a href="#" class="button continue-shopping">Continue Shopping</a></div></div></div></div>';

            // Append the popup to the body
            $('body').append(popup_html);

            if (fragments['div.fish_cross_sells']) {
                $('.fishouflage-add-to-cart-popup-content .products').html(fragments['div.fish_cross_sells']);
            }

            if (fragments['div.fish_cart_total']) {
                var progress = fragments['div.fish_cart_total'].progress;
                var remaining = fragments['div.fish_cart_total'].remaining;
                $('.fishouflage-add-to-cart-popup-content .progress-bar span').css('width', progress + '%');
                if (remaining > 0) {
                    $('.fishouflage-add-to-cart-popup-content .shipping-progress p').html('You are $' + remaining + ' away from Free Shipping!');
                } else {
                    $('.fishouflage-add-to-cart-popup-content .shipping-progress p').html('You have qualified for Free Shipping!');
                }
            }


            if (fragments['div.fish_product_category_url']) {
                $('.fishouflage-add-to-cart-popup-content .continue-shopping').attr('href', fragments['div.fish_product_category_url']);
            }

            // After cross-sells are loaded, find the tallest card and set all to that height
            setTimeout(function () {
                var $productCards = $('.fishouflage-add-to-cart-popup-content .cross-sells .product');
                var maxHeight = 0;

                // Find the tallest card
                $productCards.each(function () {
                    var cardHeight = $(this).outerHeight();
                    if (cardHeight > maxHeight) {
                        maxHeight = cardHeight;
                    }
                });

                // Set all cards to the same height
                if (maxHeight > 0) {
                    $productCards.css('height', maxHeight + 'px');
                }
            }, 100); // Small delay to ensure DOM is fully rendered



            // Expand the popup from the bottom with animation and accessibility
            // Add a class to body to prevent background scroll and for overlay styling
            $('body').addClass('fishouflage-popup-open');

            // Set initial state for bottom expansion
            var $popupWrapper = $('.fishouflage-add-to-cart-popup-wrapper');
            var $popupContent = $popupWrapper.find('.fishouflage-add-to-cart-popup-content');

            // Ensure popup is hidden and positioned at the bottom initially
            $popupWrapper.css({
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                top: 'auto',
                width: '100%',
                height: 'auto',
                'z-index': 9999,
                display: 'flex',
                'justify-content': 'center',
                'align-items': 'flex-end',
                background: 'rgba(0,0,0,0.4)'
            });

            $popupContent.css({
                transform: 'translateY(100%)',
                transition: 'transform 0.4s cubic-bezier(0.4,0,0.2,1)',
                'max-width': '420px',
                width: '100%',
                'border-radius': '16px 16px 0 0',
                'box-shadow': '0 -4px 24px rgba(0,0,0,0.15)',
                background: '#fff',
                margin: 0
            });

            // Animate popup in from the bottom
            setTimeout(function () {
                $popupContent.css('transform', 'translateY(0)');
            }, 10);

            // Accessibility: focus the popup for screen readers
            $popupContent.attr('tabindex', '-1').focus();

            // Keyboard accessibility: close on Escape
            $(document).on('keydown.fishouflage-popup', function (e) {
                if (e.key === 'Escape') {
                    $('.close-popup').trigger('click');
                }
            });

            // Close the popup
            $('.close-popup, .continue-shopping').on('click', function (e) {
                e.preventDefault();
                $('.fishouflage-add-to-cart-popup-wrapper').fadeOut(function () {
                    $('body').removeClass('fishouflage-popup-open');
                });
            });

        }
    });
});